import { Helmet } from "react-helmet";
import {
    Box,
    Container,
    Grid,
    Typography
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import ByPosition from "./byPosition";
import ByJobCode from "./byJobCode";
import ByEmployee from "./byEmployee";
import ByEmployeeGroup from "./ByEmployeeGroup";
import ByEmployeeSubGroup from "./byEmployeeSubGroup";
import competencyMapping from "../../../../services/competencyMapping.service";
import adminService from "../../../../services/admin.service";
import * as Util from "../../../../services/global.service";

const useStyles = makeStyles({

});
const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};

const CompetencyMapping = () => {
    let { serial } = useParams()
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { state } = useLocation();
    const [open, setOpen] = React.useState(false);
    let [cycle, setCycle] = React.useState([]);
    let [cycleOld, setCycleOld] = React.useState([]);
    let [type, setType] = React.useState("");
    let [list, setList] = React.useState([]);
    const onScroll = (evt) => {
        if (evt !== undefined && evt !== null) {
            if (open) {
                setOpen(false)
            }
        }
    }

    useEffect(() => {
        adminService.listCycle().then((rs) => {
            setCycle(Util.formatData(rs?.data?.cycle, false) !== false ? rs?.data?.cycle : []);
            changeCycle(Util.formatData(state?.cycleID, ""))
        }).catch((err) => {

        })
        setCycleOld(Util.formatData(state?.cycleID, ""))
    }, []);

    useEffect(() => {

    }, []);

    let changeCycle = (data) => {
        competencyMapping.getListCompetencyMapping(data).then((rs) => {
            setList(Util.formatData(rs?.data?.list_competency_mapping, false) !== false ? rs?.data?.list_competency_mapping : []);
            setType(Util.formatData(rs?.data?.code, false) !== false ? rs?.data?.code : "");
        }).catch((err) => {

        })
    }
    return (
        <Box onScroll={onScroll} style={{ "max-height": "100%", "overflow-y": "auto" }}>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.end} >{t('sidebar.label.competencyMapping')}</span></Typography>
                    </Grid>

                    {type === "position" ?
                        <ByPosition data={list} cycle={cycle} type={type} changeCycle={changeCycle} cycleOld={cycleOld} open={open} setOpen={setOpen} />
                        : type === "job" ?
                            <ByJobCode data={list} cycle={cycle} type={type} changeCycle={changeCycle} cycleOld={cycleOld} open={open} setOpen={setOpen} />
                            : type === "employee" ?
                                <ByEmployee data={list} cycle={cycle} type={type} changeCycle={changeCycle} cycleOld={cycleOld} open={open} setOpen={setOpen} />
                                : type === "empgroup" ?
                                    <ByEmployeeGroup data={list} cycle={cycle} type={type} changeCycle={changeCycle} cycleOld={cycleOld} open={open} setOpen={setOpen} />
                                    : type === "empsubgroup" ?
                                        <ByEmployeeSubGroup data={list} cycle={cycle} type={type} changeCycle={changeCycle} cycleOld={cycleOld} open={open} setOpen={setOpen} />
                                        : null
                    }
                </Container>
            </Box>
        </Box>
    );
};
export default CompetencyMapping;
